// Dizzplace - biblioteka karuzeli NA ZADANIE.
//
// Swiper wazy 144 kB, czyli tyle co cala reszta skryptow motywu razem. Do
// 21 wrzesnia 2026 kazda strona z karuzela albo z powiekszeniem zdjecia
// sciagala go przy wczytaniu - takze wtedy, gdy klient nigdy nie dojechal do
// karuzeli i nie otworzyl okna. Na stronie glownej nie uzywa go NIC poza
// oknem powiekszenia, wiec 144 kB szlo w calosci w prozne.
//
// Teraz plik wchodzi dopiero, gdy jest potrzebny: karuzela prosi o niego, gdy
// zbliza sie do ekranu, a powiekszenie zdjecia - przy pierwszym otwarciu.
//
// Adresy plikow zna wylacznie Liquid, wiec przychodza w atrybutach znacznika,
// ktory ten skrypt wczytal. Sekcja, ktorej arkusz karuzeli potrzebny jest
// dopiero razem z biblioteka (okno powiekszenia), podaje go przez
// `data-swiper-css` zamiast wpinac go w naglowku strony.

if (!window.dizzSwiper) {
  window.dizzSwiper = (() => {
    const znacznik = document.currentScript || document.querySelector('script[data-swiper-src]');
    const zrodlo = znacznik && znacznik.dataset.swiperSrc;
    const arkusz = znacznik && znacznik.dataset.swiperCss;
    let obietnica = null;

    // Arkusz karuzeli wchodzi po wczytaniu strony, a nie na zadanie: gdyby
    // czekal na klikniecie razem z biblioteka, slajdy mrugnelyby przez chwile
    // jedne pod drugimi. Wpiety w ten sposob nie blokuje pierwszego rysowania.
    const wstawArkusz = () => {
      if (!arkusz || document.querySelector(`link[data-swiper-css="${arkusz}"]`)) return;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = arkusz;
      link.dataset.swiperCss = arkusz;
      document.head.appendChild(link);
    };

    if (arkusz) {
      if ('requestIdleCallback' in window) window.requestIdleCallback(wstawArkusz, { timeout: 2000 });
      else window.addEventListener('load', wstawArkusz, { once: true });
    }

    const dolacz = () => new Promise((spelnij, odrzuc) => {
      if (typeof window.Swiper === 'function') {
        spelnij(window.Swiper);
        return;
      }
      if (!zrodlo) {
        odrzuc(new Error('Brak adresu biblioteki karuzeli'));
        return;
      }

      wstawArkusz();

      const skrypt = document.createElement('script');
      skrypt.src = zrodlo;
      skrypt.addEventListener('load', () => spelnij(window.Swiper));
      skrypt.addEventListener('error', () => odrzuc(new Error('Nie udalo sie wczytac biblioteki karuzeli')));
      document.head.appendChild(skrypt);
    });

    return {
      // Wczytuje teraz. Kolejne wywolania dostaja te sama obietnice.
      zaladuj() {
        if (!obietnica) obietnica = dolacz();
        return obietnica;
      },

      // Odklada wczytanie do chwili, gdy element zblizy sie do ekranu.
      // Zapas 400 px, zeby biblioteka byla na miejscu, zanim karuzela wjedzie
      // w kadr - inaczej karty mrugnelyby w ukladzie sprzed uruchomienia.
      przyZblizeniu(element) {
        if (typeof window.Swiper === 'function' || !('IntersectionObserver' in window)) {
          return this.zaladuj();
        }
        return new Promise((spelnij, odrzuc) => {
          const obserwator = new IntersectionObserver((wpisy) => {
            if (!wpisy.some((wpis) => wpis.isIntersecting)) return;
            obserwator.disconnect();
            this.zaladuj().then(spelnij, odrzuc);
          }, { rootMargin: '400px 0px' });
          obserwator.observe(element);
        });
      },
    };
  })();
}
